/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./engine/components/engine/engine.component.ngfactory";
import * as i3 from "./engine/components/engine/engine.component";
import * as i4 from "@ngxs/store";
import * as i5 from "./engine/animation.service";
import * as i6 from "./engine/camera.service";
import * as i7 from "./engine/engine.service";
import * as i8 from "./engine/paint.service";
import * as i9 from "@angular/router";
import * as i10 from "./app.component";
import * as i11 from "./shared/previous-route.service";
import * as i12 from "./shared/analytics.service";
var styles_AppComponent = [i0.styles];
var RenderType_AppComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppComponent, data: {} });
export { RenderType_AppComponent as RenderType_AppComponent };
export function View_AppComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-engine", [], null, [[null, "wheel"], [null, "contextmenu"], [null, "mouseout"]], function (_v, en, $event) { var ad = true; if (("wheel" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1).wheel($event) !== false);
        ad = (pd_0 && ad);
    } if (("contextmenu" === en)) {
        var pd_1 = (i1.ɵnov(_v, 1).contextmenu($event) !== false);
        ad = (pd_1 && ad);
    } if (("mouseout" === en)) {
        var pd_2 = (i1.ɵnov(_v, 1).mouseout($event) !== false);
        ad = (pd_2 && ad);
    } return ad; }, i2.View_EngineComponent_0, i2.RenderType_EngineComponent)), i1.ɵdid(1, 245760, null, 0, i3.EngineComponent, [i4.Actions, i5.AnimationService, i6.CameraService, i1.ChangeDetectorRef, i7.EngineService, i8.PaintService, i1.Renderer2, i4.Store], null, null), (_l()(), i1.ɵeld(2, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(3, 212992, null, 0, i9.RouterOutlet, [i9.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); _ck(_v, 3, 0); }, null); }
export function View_AppComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-root", [], null, null, null, View_AppComponent_0, RenderType_AppComponent)), i1.ɵdid(1, 245760, null, 0, i10.AppComponent, [i11.PreviousRouteService, i12.AnalyticsService, i9.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AppComponentNgFactory = i1.ɵccf("app-root", i10.AppComponent, View_AppComponent_Host_0, {}, {}, []);
export { AppComponentNgFactory as AppComponentNgFactory };
